import React from "react";
import { SpaceBetweenAlignContent } from "../CustomAntdComponents/Utitlities";
import {
  StyledParagraph,
  StyledTitle,
} from "../CustomAntdComponents/Typography";
import { passengerCategoryLabel } from "../PassengerFormItem/helpers";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { BreakdownWrapper } from "./styles";
import {
  calculateFlightFareBreakdown,
  calculateFlightTotalFare,
  calculateTicketTotal,
  calculateTicketTotalOldPrice,
  calculateTicketTotalDiscountPrice,
} from "../AvailableFlights/helper";
import { useFlightSearchStore } from "../../store/flightSearch/flightSearchStore";
import { useBookingStore } from "../../store/booking/bookingStore";
import { TripLabel } from "../RoadItineraryBreakdown/styles";
import { StrikeThroughAmount } from "../AvailableFlights/styles";
import { useI18nContext } from "../../utils/I18n";
import translations from "../../screens/PassengerDetails/translations";

type Props = {
  hideBreakdown: boolean;
};
const FlightFareBreakdown = ({ hideBreakdown }: Props) => {
  const {
    selectedFlight,
    formData: { isDomestic },
  } = useFlightSearchStore();

  const {
    state: { t },
  } = useI18nContext();

  const { bookingPayload, confirmData } = useBookingStore();
  const { totalTicketAmount, totalOriginalPrice } = calculateFlightTotalFare(
    selectedFlight,
    isDomestic
  );
  const departureFares = calculateFlightFareBreakdown([selectedFlight[0]]);
  const returnFares =
    isDomestic && selectedFlight.length > 1
      ? calculateFlightFareBreakdown([selectedFlight[1]])
      : null;
  const bookingAmount = bookingPayload
    ? calculateTicketTotal(bookingPayload.TicketingDetails)
    : totalTicketAmount;

  const totalOldPrice = confirmData
    ? calculateTicketTotalOldPrice(confirmData)
    : 0;

  const discountAmount = confirmData
    ? calculateTicketTotalDiscountPrice(confirmData)
    : 0;

  return (
    <div>
      {!hideBreakdown && (
        <BreakdownWrapper>
          {returnFares && <TripLabel size="normal">Departure</TripLabel>}
          {departureFares.map((f, key) => (
            <SpaceBetweenAlignContent key={key}>
              <StyledParagraph style={{ fontSize: "14px" }}>
                {passengerCategoryLabel(f.PassengerType)} &nbsp;x&nbsp;{" "}
                {f.Quantity}
              </StyledParagraph>

              <StyledTitle level={5} style={{ color: "#434455" }}>
                {formatNumberAsCurrency(
                  f.TotalFare * f.Quantity || 0,
                  selectedFlight[0]?.Currency
                )}
              </StyledTitle>
            </SpaceBetweenAlignContent>
          ))}

          {returnFares && (
            <div style={{ marginTop: "10px" }}>
              <TripLabel size="normal">Return</TripLabel>
              {returnFares.map((f, key) => (
                <SpaceBetweenAlignContent key={key}>
                  <StyledParagraph style={{ fontSize: "14px" }}>
                    {passengerCategoryLabel(f.PassengerType)} &nbsp;x&nbsp;{" "}
                    {f.Quantity}
                  </StyledParagraph>

                  <StyledTitle level={5} style={{ color: "#434455" }}>
                    {formatNumberAsCurrency(
                      f.TotalFare * f.Quantity || 0,
                      selectedFlight[0]?.Currency
                    )}
                  </StyledTitle>
                </SpaceBetweenAlignContent>
              ))}
            </div>
          )}
        </BreakdownWrapper>
      )}

      <SpaceBetweenAlignContent>
        {confirmData?.length && confirmData[0]?.IsDiscounted ? (
          <p className="total-passengers-text">Total for all passengers</p>
        ) : (
          <StyledParagraph size="default">
            Total for all passengers
          </StyledParagraph>
        )}

        <div className="make-payment-amount-wrapper">
          {confirmData?.length && confirmData[0]?.IsDiscounted ? (
            <StrikeThroughAmount>
              {formatNumberAsCurrency(
                bookingAmount + discountAmount,
                selectedFlight[0]?.Currency
              )}
            </StrikeThroughAmount>
          ) : selectedFlight[0].IsDiscounted ? (
            <StrikeThroughAmount>
              {formatNumberAsCurrency(
                totalOriginalPrice,
                selectedFlight[0]?.Currency
              )}
            </StrikeThroughAmount>
          ) : null}
          <StyledTitle level={3}>
            {formatNumberAsCurrency(
              bookingAmount || 0,
              selectedFlight[0]?.Currency
            )}
          </StyledTitle>
        </div>
      </SpaceBetweenAlignContent>

      {confirmData?.length && confirmData[0]?.IsDiscounted ? (
        <div className="discount-container-desktop ">
          <span>{t(translations).discountApplied}</span>
          <span className="discount-code-text">
            {confirmData[0]?.PassengerDetails?.PromoCode}
          </span>
          <span className="discount-amount-off-text">
            (
            {formatNumberAsCurrency(
              discountAmount,
              selectedFlight[0]?.Currency
            )}{" "}
            {t(translations).off})
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default FlightFareBreakdown;
